import { originalGameName } from './gameNameI18n';
const CHARACTER_SKILL_SOUND_DIR = '/music/character';

/** Savaş ekranındaki beceri sesi. İsim bayrakları character.go applySkillTypeFlags ile aynı. */
export function withSkillTypeFlags(skill) {
  if (!skill) return null;
  const name = originalGameName(skill.skillName || '');
  const next = { ...skill };
  switch (name) {
    case 'Rüzgâr Çeliği':
      next.isBuffSkill = true;
      break;
    case 'Kızıl Hiddet':
      next.isOfke = true;
      break;
    case 'Kasırga Kılıç':
      next.isKilicCevirme = true;
      break;
    case 'Akın':
      next.isHamle = true;
      break;
    case 'Üç Kanat Kesiği':
      next.isUcYonluKesme = true;
      break;
    case 'Son Nefes':
      next.isYasamaIsteGi = true;
      break;
    case 'Demir Ten':
      next.isDefenseBuff = true;
      break;
    case 'Yer Sarsan':
      next.isGucluVurus = true;
      break;
    case 'Gürz Vuruşu':
      next.isSiddetliVurus = true;
      break;
    case 'Yarma':
      next.isKilicDarbesi = true;
      break;
    case 'Can Darbesi':
      next.isRuhVurusu = true;
      break;
    case 'Çelik Halka':
      next.isKilicCemberi = true;
      break;
    case 'Gölge Pençesi':
      next.isHayaletVurus = true;
      break;
    case 'Kül Kalkanı':
      next.isKaranlikKoruma = true;
      break;
    case 'Kor Ruhu':
      next.isAtesHayaleti = true;
      break;
    case 'Kızıl Alev':
      next.isAlevVurusu = true;
      break;
    case 'Kara Dalga':
      next.isKaranlikVurus = true;
      break;
    case 'Tılsımlı Ağız':
      next.isBuyuluKeskinlik = true;
      break;
    case 'Mühür Kırıcı':
      next.isBuyuCozme = true;
      break;
    case 'Damga':
      next.isParmakDarbesi = true;
      break;
    case 'Evren Dönüşü':
      next.isEjderhaDonusu = true;
      break;
    case 'Korku Sisi':
      next.isDehset = true;
      break;
    case 'Rün Zırhı':
      next.isBuyuluZirh = true;
      break;
    case 'Lanet Taşı':
      next.isKaranlikTas = true;
      break;
    default:
      break;
  }
  if (!next.effectFile && next.id) {
    next.effectFile = `image/skills/effects/${next.id}.png`;
  }
  return next;
}

export function getSkillUseSound(skill) {
  if (!skill) return null;
  const flagged = withSkillTypeFlags(skill);
  const name = originalGameName(flagged.skillName || '');

  if (
    flagged.isDefenseBuff || flagged.isOfke || flagged.isBuffSkill
    || flagged.isAtesHayaleti || flagged.isKaranlikKoruma
    || flagged.isBuyuluKeskinlik || flagged.isBuyuluZirh
    || flagged.isDehset
    || name === 'Korku Sisi'
  ) {
    return `${CHARACTER_SKILL_SOUND_DIR}/skill1.MP3`;
  }

  if (name === 'Son Nefes' || name.startsWith('Yaşama')) {
    return `${CHARACTER_SKILL_SOUND_DIR}/skill2.MP3`;
  }

  if (
    flagged.isGucluVurus || flagged.isHamle
    || flagged.isEjderhaDonusu || flagged.isAlevVurusu
  ) {
    return `${CHARACTER_SKILL_SOUND_DIR}/skill3.MP3`;
  }

  if (
    flagged.isSiddetliVurus || flagged.isRuhVurusu || flagged.isUcYonluKesme || flagged.isKilicCevirme
    || flagged.isParmakDarbesi || flagged.isKaranlikTas
    || name === 'Lanet Taşı'
  ) {
    return `${CHARACTER_SKILL_SOUND_DIR}/skill4.MP3`;
  }

  if (
    flagged.isKilicCemberi || flagged.isKilicDarbesi
    || flagged.isBuyuCozme || flagged.isHayaletVurus || flagged.isKaranlikVurus
  ) {
    return `${CHARACTER_SKILL_SOUND_DIR}/skill5.MP3`;
  }

  return flagged.soundFile || null;
}
